import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { AppState } from "store";
//#region types
import { CommentProps } from "models/propTypes/commentViewPropTypes";
//#endregion
//#region components
import CommentDetails from "./commentDetails";
import ProfileImage from "../profile/profileImage";
import FilePreviewsGrid from "../lists/filePreviewsGrid";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const Comment: React.FC<React.PropsWithChildren<CommentProps>> = (props) => {
  const loggedInUser = useSelector((state: AppState) => state.auth.loggedInUser);

  const { from, attachments, isWint = from?.id === undefined, getImageContent, onFileClick } = props;

  const avatar = useMemo(
    () => (
      <ProfileImage id={isWint ? undefined : from?.id} name={from?.name} className={cssExports.avatar}></ProfileImage>
    ),
    // By sender, not once: the list keys comments by position, so one instance can show another's comment.
    [isWint, from?.id, from?.name]
  );

  const isOther = React.useMemo(() => isWint || loggedInUser.personId !== from?.id, [isWint, loggedInUser, from?.id]);

  return (
    <Grid
      container
      className={clsx(cssExports.commentContainer, props.isAutomatic ? cssExports.commentAutomatic : "")}
      wrap="nowrap"
    >
      {avatar}
      <Grid item xs container>
        {props.message?.length ? <CommentDetails {...props} isOther={isOther} /> : <></>}

        {attachments && attachments.length > 0 && (
          <Grid item container className={cssExports.commentAttachmentsContainer}>
            <Grid item container>
              <FilePreviewsGrid
                files={attachments}
                getImageContent={
                  getImageContent ??
                  (async () => {
                    return "";
                  })
                }
                onFileClick={onFileClick}
              ></FilePreviewsGrid>
            </Grid>
          </Grid>
        )}

        {props.children ? (
          <Grid item container className={cssExports.commentChildrenContainer}>
            {props.children}
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
    </Grid>
  );
};

export default Comment;
